export const brand = {
  name: "洞洞杂货铺",
  subName: "角色与设定科普站",
  slogan: "墙上的洞通向哪里，只有店主知道。",
  description:
    "《洞洞杂货店》是一部人气悬疑韩漫：主角子强继承了爷爷在乡下经营的小杂货店，上工第一天就被带到一间奇怪的房间，墙上有一个来历不明的「洞」，自此卷入了杂货店与整座村庄流传百年的秘密之中。本站在此整理角色、人物关系与店铺设定，帮助读者快速认清漫画里的每个人。",
  genre: ["悬疑", "奇幻", "人情", "单元剧"],
  episodes: "全151话 + 外传5话",
};

export const characterStats = [
  { label: "正篇话数", value: "151" },
  { label: "外传话数", value: "5" },
  { label: "核心角色", value: "5+" },
  { label: "题材", value: "悬疑" },
];

export interface Character {
  id: string;
  name: string;
  role: string;
  identity: string;
  keywords: string[];
  intro: string;
  detail: string;
  relationship: string;
  imgSeq: string;
}

export const characters: Character[] = [
  {
    id: "ziqiang",
    name: "子强",
    role: "主人公 · 新任店主",
    identity: "接手爷爷杂货店的年轻人",
    keywords: ["继承", "店主", "好奇", "成长"],
    intro:
      "故事的主人公。子强在爷爷去世后继承了乡下的杂货店，上工第一天就被带去一间奇怪的小房间——墙上有一处莫名的小洞，而他也由此接下了「店主」这份并不寻常的工作。",
    detail:
      "子强原本只是个普通的年轻人，接手杂货店纯粹出于对爷爷的怀念。然而这家店远不止卖杂货这么简单：墙上那个「洞」会带来形形色色的访客，也会引出令人脊背发凉的请求。他一边笨拙地学着当一名合格的店主，一边逐渐被拖进店铺与村庄纠缠百年的秘密之中。他的好奇与善良，正是这部漫画层层揭开悬念的入口。",
    relationship:
      "爷爷将店铺与秘密一并托付给他；他既是店主，也是爷爷意志的继承者。",
    imgSeq: "char-ziqiang",
  },
  {
    id: "grandpa",
    name: "爷爷",
    role: "前任店主 · 已故",
    identity: "杂货店原主人，秘密的守护者",
    keywords: ["传承", "秘密", "守护", "影响深远"],
    intro:
      "店铺原来的主人，也是子强的爷爷。他经营杂货店多年，深知那间房间与「洞」背后的规矩，却从未向旁人吐露过全部真相。他的离世，是整个故事的起点。",
    detail:
      "爷爷把杂货店留给子强，也把随之而来的责任留给了他。作为前任店主，他显然知晓「洞」的来历与村庄的旧事，更懂得与「洞」打交道时要遵守的规则。他没有留下太多言语，却用这座店铺本身，把最重要的事一件件交到了子强手上。",
    relationship:
      "与子强是祖孙关系，也是前店主与继承者的关系，是连接店铺秘密的关键人物。",
    imgSeq: "char-grandpa",
  },
  {
    id: "xiaohui",
    name: "小慧",
    role: "村里的未婚妈妈",
    identity: "与店铺有复杂牵绊的村民",
    keywords: ["温柔", "坚韧", "牵绊", "人情"],
    intro:
      "居住在村里的女性，独自带着孩子的未婚妈妈。她与杂货店之间有着复杂而微妙的牵绊，也常常带着某种说不清道不明的诉求出现在故事里。",
    detail:
      "小慧是村庄人情世故的一抹温柔底色。作为未婚妈妈，她的生活并不轻松，而杂货店似乎总能在某个节点与她产生交集。她看似柔弱，却远比想象中坚韧。围绕她的单元故事，往往也是漫画最打动人心的部分之一。",
    relationship:
      "村民之一，与杂货店及店主之间存在长期的、牵扯过去的复杂联系。",
    imgSeq: "char-xiaohui",
  },
  {
    id: "xinru",
    name: "欣茹",
    role: "村里的教师",
    identity: "理性而可靠的村民",
    keywords: ["理性", "可靠", "正义感", "见证者"],
    intro:
      "在村子里任教的女教师。比起冲动，她更习惯用冷静的观察去理解事情，常常在子强迷茫时给出提醒，也是不少单元故事里关键的见证者。",
    detail:
      "欣茹是故事里「清醒的旁观者」。作为教师，她与村庄里的家庭和孩子们走得很近，也因此对村里人背后的故事格外敏感。她未必全知店铺的秘密，却总能在关键处拉子强一把，让悬疑之外多一分踏实的人情味。",
    relationship:
      "村庄的村民与教师，与主角保持着亦师亦友的信任关系。",
    imgSeq: "char-xinru",
  },
  {
    id: "neighbor",
    name: "隔壁的女性",
    role: "来历不明的邻居",
    identity: "住在店铺隔壁的神秘人物",
    keywords: ["神秘", "若即若离", "线索", "知情人"],
    intro:
      "住在杂货店隔壁房间的神秘女性。她对店铺的事似乎知道得比别人更多，却总是若即若离，行踪与身份都笼罩在一层迷雾里。",
    detail:
      "这位住在隔壁的女性是漫画里最大的谜团之一。她清楚店铺与「洞」的存在，偶尔会向子强抛出意味深长的话，却从不把话说满。她究竟是敌是友、与店铺的过去有何渊源，是追更时最让读者揪心的悬念。",
    relationship:
      "与店铺和店主的关系暧昧不明，是推动主线悬念的重要人物。",
    imgSeq: "char-neighbor",
  },
];

export interface SettingItem {
  id: string;
  title: string;
  tag: string;
  summary: string;
  body: string[];
  imgSeq: string;
}

export const settings: SettingItem[] = [
  {
    id: "store",
    title: "杂货店本体",
    tag: "舞台",
    summary: "爷爷留给子强的那间乡下小杂货店，是整部漫画的核心舞台。",
    body: [
      "这家店坐落在村子里，外表看起来就是一间普普通通的杂货铺，卖些日用品、零食和杂货。可只有接过钥匙的人才知道，店铺深处另有乾坤。",
      "店铺既是主角生活与谋生的场所，也是一个个单元故事展开的舞台。来往的村民、深夜的访客，都会让这间小店显露出不寻常的一面。",
    ],
    imgSeq: "setting-store",
  },
  {
    id: "hole",
    title: "墙上的「洞」",
    tag: "核心",
    summary: "小房间里那处来历不明的洞，是全书最关键的设定。",
    body: [
      "子强上班第一天，就被带进一间小房间，房间的墙上有一个莫名其妙的「洞」。它连接着什么、由谁而来、要付出什么代价，都是悬念的核心。",
      "围绕这个洞，杂货店不断迎来带着诉求的访客，也一步步牵出店铺与村庄流传百年的秘密。可以说，故事的一切都从这个洞开始。",
    ],
    imgSeq: "setting-hole",
  },
  {
    id: "rules",
    title: "店主的规矩",
    tag: "规则",
    summary: "与「洞」打交道并非没有边界，前任店主留下了一套必须遵守的规矩。",
    body: [
      "爷爷留给子强的不只是一家店，还有一套与「洞」相处的规则。何时能开口、何时该沉默、什么请求不能答应——这些规矩在关键时候决定生死。",
      "子强正是在一次次试探与踩线中，慢慢明白这些规矩背后真正的用意，也读懂了爷爷的良苦用心。",
    ],
    imgSeq: "setting-rules",
  },
  {
    id: "visitors",
    title: "深夜的访客",
    tag: "人情",
    summary: "带着各自诉求而来的人，构成了这部漫画最动人的单元故事。",
    body: [
      "村里的未婚妈妈小慧、为生活奔波的村民、以及更多说不出口的心事……杂货店就像一处深夜的避风港，收纳着人们无处安放的愿望。",
      "每一个单元故事都像一扇小窗，透过它能看到村庄里真实的人情冷暖，也让悬疑之外多了一层温柔。",
    ],
    imgSeq: "setting-visitors",
  },
  {
    id: "village",
    title: "村庄与百年秘密",
    tag: "主线",
    summary: "杂货店、洞、村庄……三者共同缠成一段跨越百年的旧事。",
    body: [
      "杂货店并非孤立存在，它与整座村庄的历史紧紧相连。店铺牵扯出的古老传说、人物间的恩怨与羁绊，共同构成推动主线的那根线。",
      "随着剧情推进，店铺的百年秘密逐渐显形，子强也不得不面对比想象中更大的真相与责任。",
    ],
    imgSeq: "setting-village",
  },
];

export interface StoryPoint {
  id: string;
  phase: string;
  title: string;
  text: string;
  tag: string;
}

export const storyPoints: StoryPoint[] = [
  {
    id: "s1",
    phase: "序章",
    title: "继承杂货店",
    text: "子强继承了爷爷的杂货店，上工第一天便被带到那间有「洞」的小房间。属于新店主的故事，从这里正式开始。",
    tag: "开端",
  },
  {
    id: "s2",
    phase: "第一章",
    title: "洞的另一头",
    text: "围绕墙上的「洞」，形形色色的访客与请求接连出现。子强在摸索规矩的过程中，逐渐窥见店铺不为人知的一面。",
    tag: "展开",
  },
  {
    id: "s3",
    phase: "第二章",
    title: "村里的人情",
    text: "小慧、欣茹与更多村民的故事陆续展开。单元剧式的叙事让悬疑之外多了人情冷暖，也让村庄的轮廓愈发清晰。",
    tag: "温情",
  },
  {
    id: "s4",
    phase: "第三章",
    title: "百年的真相",
    text: "店铺、洞与村庄的历史被一条条线牵到一起，古老传说浮现，子强开始直面那场横跨百年的秘密与责任。",
    tag: "主线",
  },
];

export interface Faq {
  id: string;
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    id: "f1",
    question: "《洞洞杂货店》是一部什么样的漫画？",
    answer:
      "它是一部人气悬疑韩漫，融合了奇幻、人情与单元剧的元素。主角子强继承爷爷的乡下杂货店后，发现店铺里有一处来历不明的「洞」，并由此卷入了店铺与村庄流传百年的秘密。",
  },
  {
    id: "f2",
    question: "洞洞杂货店的店主是谁？",
    answer:
      "故事的主人公是子强。爷爷去世后，他继承了乡下的小杂货店，成为新任店主，并接过了与墙上那个「洞」打交道的工作与责任。",
  },
  {
    id: "f3",
    question: "主要人物都有哪些？",
    answer:
      "主要人物包括新任店主子强、已故的前店主爷爷、村里的未婚妈妈小慧、村中的教师欣茹，以及住在店铺隔壁、来历不明的神秘女性。此外还有不少在单元故事中登场的村民。",
  },
  {
    id: "f4",
    question: "墙上那个「洞」到底是做什么的？",
    answer:
      "「洞」是全书的核心设定，连接着不可思议的事物与带着诉求而来的访客。关于它的来历、规则与代价，是贯穿全篇的最大悬念之一，建议亲自到正版平台去揭开答案。",
  },
  {
    id: "f5",
    question: "这部漫画大概有多少话？",
    answer:
      "正篇全 151 话，另附 5 话外传。单元故事与主线剧情相互穿插，既适合碎片阅读，也适合一口气追完。",
  },
  {
    id: "f6",
    question: "在哪里可以看正版？",
    answer:
      "请前往漫画官方授权的正版平台搜索《洞洞杂货店》在线阅读。本站仅做角色与设定的资料整理，不提供任何盗版内容或阅读链接。",
  },
];

export const relationshipNodes = [
  { name: "子强", desc: "新任店主" },
  { name: "爷爷", desc: "前任店主" },
  { name: "隔壁女性", desc: "神秘邻居" },
  { name: "小慧", desc: "未婚妈妈" },
  { name: "欣茹", desc: "教师" },
];

export const relationshipEdges = [
  { from: "子强", to: "爷爷", type: "祖孙传承" },
  { from: "子强", to: "隔壁女性", type: "共同守护" },
  { from: "子强", to: "小慧", type: "村民羁绊" },
  { from: "子强", to: "欣茹", type: "亦师亦友" },
  { from: "隔壁女性", to: "爷爷", type: "旧识之谜" },
  { from: "小慧", to: "欣茹", type: "村民情谊" },
];